import Http from "./http";

export const getMaterialDetailsAPI = (payload, options) => {
  return Http.post("admin/material/get", payload, options);
};
